<template>
    <div class="columns" v-if="!submitted && !submitting">
        <div class="column is-half contact-photo">
            <img src="../../static/storefront.png" alt="McDiarmid Flowers Storefront">
        </div>

        <div class="column is-half">
            <form>
                <b-field label="First Name" :message="errors.first('first_name')" expanded>
                    <b-input placeholder="First Name" v-model.trim="first_name" v-validate="{ required: true, min: 2, max: 45 }" name="first_name"></b-input>
                </b-field>
                <b-field label="Last Name" :message="errors.first('last_name')" expanded>
                    <b-input placeholder="Last Name" v-model.trim="last_name" v-validate="{ required: true, min: 2, max: 45 }" name="last_name"></b-input>
                </b-field>
                <b-field label="Email" :message="errors.first('email')">
                    <b-input placeholder="example@email.com" v-model.trim="email" v-validate="{ required: true, email: true }" name="email"></b-input>
                </b-field>
                <b-field label="Subject" :message="errors.first('subject')">
                    <b-input placeholder="Subject" v-model.trim="subject" v-validate="{ required: true, min: 4, max: 80}" name="subject"></b-input>
                </b-field>
                <b-field label="Message" :message="errors.first('message')">
                    <b-input type="textarea" placeholder="We are so excited to hear from you and we look forward to working with you in making your wedding, event and personal occasion that more more special and unique." v-model.trim="message" v-validate="{ required: true, min: 5, max: 1500 }" name="message"></b-input>
                </b-field>
                <b-field>
                    <p class="control">
                        <button type="button" class="button is-primary" @click="submit">Submit</button>
                    </p>
                </b-field>
            </form>
        </div>
    </div>

    <loader v-else-if="submitting"></loader>
    <b-notification type="is-success" has-icon v-else-if="submitted">
        Message sent successfully
    </b-notification>
</template>

<script>
import Loader from './Loader';

export default {
  components: {
    Loader,
  },
  name: 'contact-us-form',

  data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      subject: '',
      message: '',

      submitted: false,
      submitting: false,
    };
  },

  methods: {
    submit() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.submitting = true;
          this.post();
        }
      });
    },

    post() {
      let contactForm = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        subject: this.subject,
        message: this.message,
      };

      this.$store.dispatch('contact/submit', contactForm).then(() => {
        // console.log('Contacted');
        this.submitting = false;
        this.submitted = true;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ContactUsForm.vue